import { Drawer } from "@design-system/Drawer";
import { OverlayContainerProvider } from "@design-system/overlay/OverlayContainerProvider";
import React, { useRef } from "react";
import styles from "./RulesDrawer.module.scss";
import { RulesDrawerHeader } from "./RulesDrawerHeader";

interface RulesDrawerProps {
    children: React.ReactNode;
    headerText: string;
    headerClassName?: string;
    contentClassName?: string;
    open: boolean;
    onClose: () => void;
}

export const RulesDrawer: React.FC<RulesDrawerProps> = ({
    children,
    headerText,
    headerClassName,
    contentClassName,
    open,
    onClose,
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <Drawer
            open={open}
            onClose={onClose}
            direction="right"
            modal={false}
            contentClassName={contentClassName}
            headerAddonLeft={
                <RulesDrawerHeader
                    text={headerText}
                    className={headerClassName}
                />
            }
            noPadding
            size="fullScreen"
        >
            <OverlayContainerProvider containerRef={containerRef}>
                <div ref={containerRef} className={styles.rulesDrawerContent}>
                    {children}
                </div>
            </OverlayContainerProvider>
        </Drawer>
    );
};
